


















/* tslint:disable:no-magic-numbers */
import { Component, Prop, Vue } from "vue-property-decorator";
import { WellKnownRouter } from "@infrastructure/config/router";
import { HttpErrorMessages } from "@proxy/HttpErrorMessages";

@Component
export default class Error extends Vue {
    @Prop() errorCode: number;

    private homeRoute: string = WellKnownRouter.Home;

    private get generalErrorMessage() {
        let errorNo = Number(this.errorCode);

        switch (errorNo) {
            case 403:
                return HttpErrorMessages.Http403;
            case 404:
                return HttpErrorMessages.Http404;
            default:
                return HttpErrorMessages.HttpError;
        }
    }

    get displayErrorCode(): string {
        let errorNo = Number(this.errorCode);

        if (errorNo >= 400 && errorNo <= 600) {
            return errorNo.toString();
        }
        return "500";
    }
}
